import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '@material';

import { InformationStoreModule } from '@core/store';
import { LayoutModule } from '@angular/cdk/layout';
import { FormsModule } from '@angular/forms';

import * as fromComponents from '@core/components';
import * as fromContainers from '@core/containers';
import { AppComponent } from '@core/containers/app/app.component';
import { AuthorizedGuard } from '@core/guards/authorized.guard';
import { ErrorComponent } from '@core/containers/error/error.component';

//import { InlineSVGModule } from 'ng-inline-svg';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { MeteringFilterComponent } from '@core/components/metering-filter/metering-filter.component';
import { MeteringFilterConfigFormComponent } from '@core/components/metering-filter-config-form/metering-filter-config-form.component';
import { MenuComponent } from '@core/components/menu/menu.component';
import { PortalModule } from '@angular/cdk/portal';
import { TranslateModule } from '@ngx-translate/core';
import { SecurityTrimComponent } from '@core/components/security-trim/security-trim.component';
import { PermissionGuard } from '@core/guards/permission.guard';
import { DateFilterPaneComponent } from '@core/components/date-filter-pane/date-filter-pane.component';
import { MultiChoiceFilterPaneComponent } from '@core/components/multi-choice-filter-pane/multi-choice-filter-pane.component';
import { ValueRangeFilterPaneComponent } from '@core/components/value-range-filter-pane/value-range-filter-pane.component';
import { CheckBoxFilterPaneComponent } from '@core/components/checkbox-filter-pane/checkbox-filter-pane.component';
import { PipesModule, ToLocalStringPipe } from '@utils/pipes';
import { ToLocalDateTimePipe } from '@utils/pipes/to-local-date-time.pipe';
import { DirectivesModule, RouterLinkDirective, SelectedTabDirective, SetInformationAsReadDirective } from '@utils/directives';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DateAdapter } from '@angular/material/core';
import { DateFilterComponent } from './components/date-filter/date-filter.component';
import { ReloadPromptComponent } from './components/reload-prompt/reload-prompt.component';
import { SwedishDateAdapter } from '@utils/SwedishDateAdapter';
import { TrackClickDirective } from '@utils/directives/track-click.directive';
import { OnboardingHeaderComponent } from './components/onboarding-header/onboarding-header.component';
import { CertificatesComponent } from './components/certificates/certificates.component';
import { SxDynamicFilterComponentsService } from '@services';
import { FilterWrapperComponent } from '@core/containers';
import { AutoFocusDirective } from '@utils/directives/auto-focus.directive';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MaterialModule,
    LayoutModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatIconModule,
    MatListModule,
    MatInputModule,
    MatSlideToggleModule,
    FormsModule,
    InformationStoreModule,
    AngularSvgIconModule.forRoot(),
    PortalModule,
    TranslateModule,
    PipesModule,
    DirectivesModule

  ],
  providers: [
    { provide: DateAdapter, useClass: SwedishDateAdapter },
    AuthorizedGuard,
    PermissionGuard,
    ToLocalStringPipe,
    ToLocalDateTimePipe,
    RouterLinkDirective,
    TrackClickDirective,
    SelectedTabDirective,
    AutoFocusDirective,
    SetInformationAsReadDirective,
    SxDynamicFilterComponentsService
  ],
  declarations: [
    AppComponent,
    ...fromContainers.containers,
    ...fromComponents.components,
    ErrorComponent,
    MeteringFilterComponent,
    MeteringFilterConfigFormComponent,
    MenuComponent,
    SecurityTrimComponent,
    DateFilterComponent,
    ReloadPromptComponent,
    OnboardingHeaderComponent,
    CertificatesComponent,
    ValueRangeFilterPaneComponent,
    MultiChoiceFilterPaneComponent,
    DateFilterPaneComponent,
    CheckBoxFilterPaneComponent,
  ],
  exports: [AppComponent, FilterWrapperComponent, ...fromContainers.containers, ...fromComponents.components]
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: []
    };
  }
}
